/* eslint-disable func-names */
import 'intersection-observer';
import 'lazysizes';

// Individual Bootstrap components
import 'bootstrap/js/dist/collapse';

// Site components
import Scrolling from './modules/scrolling';
import Tracking from './modules/tracking';

// Site styles
import '../css/app.scss';

function ClearSessions() {
	$('.session')
		.removeClass('bg-light border-primary')
		.find('.btn')
		.attr('disabled', 'disabled')
		.removeClass('btn-success');
}

function formatDate(date, format, utc) {
	let frmt = format;
	const MMMM = [
		'\x00',
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December'
	];
	const MMM = ['\x01', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	const dddd = ['\x02', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	const ddd = ['\x03', 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

	function ii(i, len) {
		let s = `${i}`;
		// eslint-disable-next-line no-param-reassign
		len = len || 2;
		while (s.length < len) s = `0${s}`;
		return s;
	}

	const y = utc ? date.getUTCFullYear() : date.getFullYear();
	frmt = frmt.replace(/(^|[^\\])yyyy+/g, `$1${y}`);
	frmt = frmt.replace(/(^|[^\\])yy/g, `$1${y.toString().substr(2, 2)}`);
	frmt = frmt.replace(/(^|[^\\])y/g, `$1${y}`);

	const M = (utc ? date.getUTCMonth() : date.getMonth()) + 1;
	frmt = frmt.replace(/(^|[^\\])MMMM+/g, `$1${MMMM[0]}`);
	frmt = frmt.replace(/(^|[^\\])MMM/g, `$1${MMM[0]}`);
	frmt = frmt.replace(/(^|[^\\])MM/g, `$1${ii(M)}`);
	frmt = frmt.replace(/(^|[^\\])M/g, `$1${M}`);

	const d = utc ? date.getUTCDate() : date.getDate();
	frmt = frmt.replace(/(^|[^\\])dddd+/g, `$1${dddd[0]}`);
	frmt = frmt.replace(/(^|[^\\])ddd/g, `$1${ddd[0]}`);
	frmt = frmt.replace(/(^|[^\\])dd/g, `$1${ii(d)}`);
	frmt = frmt.replace(/(^|[^\\])d/g, `$1${d}`);

	const H = utc ? date.getUTCHours() : date.getHours();
	frmt = frmt.replace(/(^|[^\\])HH+/g, `$1${ii(H)}`);
	frmt = frmt.replace(/(^|[^\\])H/g, `$1${H}`);

	// eslint-disable-next-line no-nested-ternary
	const h = H > 12 ? H - 12 : H === 0 ? 12 : H;
	frmt = frmt.replace(/(^|[^\\])hh+/g, `$1${ii(h)}`);
	frmt = frmt.replace(/(^|[^\\])h/g, `$1${h}`);

	const m = utc ? date.getUTCMinutes() : date.getMinutes();
	frmt = frmt.replace(/(^|[^\\])mm+/g, `$1${ii(m)}`);
	frmt = frmt.replace(/(^|[^\\])m/g, `$1${m}`);

	const s = utc ? date.getUTCSeconds() : date.getSeconds();
	frmt = frmt.replace(/(^|[^\\])ss+/g, `$1${ii(s)}`);
	frmt = frmt.replace(/(^|[^\\])s/g, `$1${s}`);

	let f = utc ? date.getUTCMilliseconds() : date.getMilliseconds();
	frmt = frmt.replace(/(^|[^\\])fff+/g, `$1${ii(f, 3)}`);
	f = Math.round(f / 10);
	frmt = frmt.replace(/(^|[^\\])ff/g, `$1${ii(f)}`);
	f = Math.round(f / 10);
	frmt = frmt.replace(/(^|[^\\])f/g, `$1${f}`);

	const T = H < 12 ? 'AM' : 'PM';
	frmt = frmt.replace(/(^|[^\\])TT+/g, `$1${T}`);
	frmt = frmt.replace(/(^|[^\\])T/g, `$1${T.charAt(0)}`);

	const t = T.toLowerCase();
	frmt = frmt.replace(/(^|[^\\])tt+/g, `$1${t}`);
	frmt = frmt.replace(/(^|[^\\])t/g, `$1${t.charAt(0)}`);

	let tz = -date.getTimezoneOffset();
	// eslint-disable-next-line no-nested-ternary
	let K = utc || !tz ? 'Z' : tz > 0 ? '+' : '-';
	if (!utc) {
		tz = Math.abs(tz);
		const tzHrs = Math.floor(tz / 60);
		const tzMin = tz % 60;
		K += `${ii(tzHrs)}:${ii(tzMin)}`;
	}
	frmt = frmt.replace(/(^|[^\\])K/g, `$1${K}`);

	const day = (utc ? date.getUTCDay() : date.getDay()) + 1;
	frmt = frmt.replace(new RegExp(dddd[0], 'g'), dddd[day]);
	frmt = frmt.replace(new RegExp(ddd[0], 'g'), ddd[day]);

	frmt = frmt.replace(new RegExp(MMMM[0], 'g'), MMMM[M]);
	frmt = frmt.replace(new RegExp(MMM[0], 'g'), MMM[M]);

	frmt = frmt.replace(/\\(.)/g, '$1');

	return frmt;
}

function DayOf() {
	$('[data-time]')
		.each(function() {
			const d = new Date($(this).data('time'));
			$(this).text(formatDate(d, 'h:mmtt'));
		})
		.next('.timezone')
		.hide();

	const now = new Date();
	const $sessions = $('.session');
	$sessions.each((i, session) => {
		const $session = $(session);
		setTimeout(() => {
			ClearSessions();
			$session[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
			$session
				.addClass('bg-light border-primary')
				.find('.btn')
				.removeAttr('disabled')
				.addClass('btn-success');
		}, new Date($session.data('start')) - now);
		setTimeout(() => {
			ClearSessions();
			$('#thank-you')
				.removeClass('d-none')[0]
				.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}, new Date($('#sessions').data('end')) - now);
	});

	$('a').on('click', event => !$(event.currentTarget).attr('disabled'));
}

// DOM ready:
$(() => {
	$('html').removeClass('no-js');

	// Init common modules
	Scrolling.Init();
	Tracking.Init();
});
